export interface IattendanceItem {
  id?: string;
  authorUid: string;
  createdAt: Date;
  contents: string; // 출석 글 내용
  date: string; // YYYY-MM-DD 형식
  price?: number; // 지급된 보상
  isRewarded?: boolean; // 보상 지급 여부
}

export interface IattendanceRewardSetting {
  id?: string;
  isActive: boolean; // 출석 기능 활성화 여부
  rewardPrice: number; // 출석 시 지급할 보상
  requireContent: boolean; // 내용 필수 여부 (false면 버튼만 눌러도 출석)
  placeholder?: string; // 출석 입력창 플레이스홀더 (기본값: '오늘 하루는 어떠셨나요?')
  streakRewards?: IStreakReward[]; // 연속 출석 보상 목록
}

// 연속 출석 보상 타입
export type StreakRewardType = 'currency' | 'item' | 'title';

export const STREAK_REWARD_TYPE_LABELS: Record<StreakRewardType, string> = {
  currency: '재화',
  item: '아이템',
  title: '타이틀',
};

// 연속 출석 보상 설정
export interface IStreakReward {
  id: string;
  requiredDays: number; // 연속 출석 일수 (예: 7, 14, 30)
  rewardType: StreakRewardType; // 보상 타입
  rewardAmount?: number; // 재화 수량 (rewardType === 'currency')
  rewardItemId?: string; // 아이템 ID (rewardType === 'item')
  rewardTitleId?: string; // 타이틀 ID (rewardType === 'title')
  isActive: boolean;
}

